










































import {Component, Vue} from 'vue-property-decorator';

@Component({
  components: {
  },
  metaInfo: {
    title: 'ChecksReview',
  },
})
export default class ConfirmDialog extends Vue {

  private dialog: boolean = false;
  private resolve: any = null;
  private reject: any = null;
  private message: any = null;
  private title: any = null;
  private options: object = {
    color: 'grey lighten-3',
    width: 400,
    zIndex: 200,
    noconfirm: false,
  };

  public open(title: string, message: string, options: object) {
    this.dialog = true;
    this.title = title;
    this.message = message;
    this.options = Object.assign(this.options, options);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  public agree() {
    this.resolve(true);
    this.dialog = false;
  }

  public cancel() {
    this.resolve(false);
    this.dialog = false;
  }

}
